var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"environment-ribbon",attrs:{"role":"status"}},[_c('i',{staticClass:"fas fa-exclamation-triangle environment-ribbon__icon",attrs:{"aria-hidden":"true"}}),_c('span',[_c('strong',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }